const endpoint = () => `${window.Shopify?.routes?.root || '/'}apps/kunnie/guide-community`;
class KunnieGuideCommunity extends HTMLElement {
  #controller;
  #copy;
  #page = 0;
  #busy = false;
  #requestId = null;
  #payload = null;
  connectedCallback() {
    this.#controller = new AbortController();
    this.#copy = JSON.parse(this.querySelector('[data-community-copy]').textContent);
    this.querySelector('form')?.addEventListener('submit', e => { e.preventDefault(); this.#submit(); }, {signal:this.#controller.signal});
    this.querySelector('[data-community-more]')?.addEventListener('click', () => this.#load(this.#page+1), {signal:this.#controller.signal});
    const button = this.querySelector('[type="submit"]');
    if (button) button.disabled = false;
    if (this.dataset.article) this.#load(0);
  }
  disconnectedCallback() { this.#controller?.abort(); }
  #status(text) { this.querySelector('[data-community-status]').textContent = text; }
  #entry(row, pending = false) {
    const entry = document.createElement('article');entry.className = 'kunnie-community__entry';
    const name = document.createElement('strong');name.textContent = row.name;entry.append(name);
    const meta = document.createElement('small');meta.textContent = [row.kind === 'question' ? this.#copy.question : '', new Date(row.created_at).toLocaleDateString(document.documentElement.lang), pending ? this.#copy.pending : ''].filter(Boolean).join(' · ');entry.append(meta);
    const body = document.createElement('p');body.textContent = row.body;entry.append(body);
    if (row.response) {
      const reply = document.createElement('div');reply.className = 'kunnie-community__reply';
      const label = document.createElement('strong');label.textContent = this.#copy.reply;
      const text = document.createElement('p');text.textContent = row.response;reply.append(label,text);entry.append(reply);
    }
    return entry;
  }
  async #load(page) {
    const more = this.querySelector('[data-community-more]');more.disabled = true;
    const url = new URL(endpoint(),location.origin);url.searchParams.set('articleId',this.dataset.article);url.searchParams.set('page',page);
    try {
      const response = await fetch(url,{credentials:'same-origin',headers:{Accept:'application/json'},signal:this.#controller.signal});
      const data = await response.json();if (!response.ok || !data.ok) throw new Error('read');
      const list = this.querySelector('[data-community-list]');
      if (page===0) list.replaceChildren();
      if (page===0 && !data.items.length && !data.mine.length) { const empty=document.createElement('p');empty.textContent=this.#copy.empty;list.append(empty); }
      for (const row of data.mine) list.append(this.#entry(row,true));
      for (const row of data.items) list.append(this.#entry(row));
      this.#page = page;more.hidden = !data.hasMore;
      if (!data.loggedIn && this.querySelector('form')) this.#login();
    } catch(e) {if(e.name!=='AbortError')this.#status(this.#copy.error);} finally {more.disabled = false;}
  }
  #login() {
    const form=this.querySelector('form');if(form)form.hidden=true;
    this.querySelector('[data-community-login]').hidden=false;
  }
  async #submit() {
    const form=this.querySelector('form');if(this.#busy || !form.reportValidity())return;
    this.#busy=true;const button=form.querySelector('[type="submit"]');button.disabled=true;this.#status('');
    this.#requestId ??= crypto.randomUUID();
    const values=new FormData(form);const payload=this.#payload ??= {id:this.#requestId,kind:values.get('kind'),name:values.get('name')||'',body:values.get('body'),locale:this.dataset.locale,articleId:this.dataset.article||null};
    let uncertain=true;
    try {
      const response=await fetch(endpoint(),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload),signal:this.#controller.signal});
      const data=await response.json();uncertain=false;if(data.error==='not_logged_in'){this.#login();return;}
      if(!response.ok||!data.ok)throw new Error('write');
      this.#requestId=null;this.#payload=null;form.reset();this.#status(this.#copy.saved);if(this.dataset.article)await this.#load(0);
    }catch(e){if(e.name!=='AbortError')this.#status(this.#copy.error);}finally{
      for(const field of form.querySelectorAll('input,select,textarea'))field.disabled=uncertain;
      if(!uncertain){this.#requestId=null;this.#payload=null;}
      this.#busy=false;button.disabled=false;
    }
  }
}
if (!customElements.get('kunnie-guide-community')) customElements.define('kunnie-guide-community',KunnieGuideCommunity);
